import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import SearchResultHeaderPanel from './panels/SearchResultHeaderPanel';
import SearchResultCheckBox from './parts/SearchResultCheckBox';
import ExportSentExecutiveListButton from './parts/ExportSentExecutiveListButton';
import ListSettingButton from './parts/ListSettingButton';
import SearchResultEmptyPanel from './panels/SearchResultEmptyPanel';
import SearchResultPanel from './panels/SearchResultPanel';

const styles = () => ({
  flex: {
    flex: 1,
  },
});

class AddressTable extends React.Component {
  render() {
    const { filteredItems, classes } = this.props;

    return (
      <div style={this.props.style}>
        {
          (filteredItems.length === 0) ? (
            <SearchResultEmptyPanel />
          ) : (
            <div>
              <SearchResultHeaderPanel style={{ padding: 0 }}>
                <SearchResultCheckBox
                  user={this.props.user}
                  totalCount={this.props.totalCount}
                  isSelectAll={this.props.isSelectAll}
                  selectCount={this.props.selectCount}
                  selectedItems={this.props.selectedItems}
                  unselectedItems={this.props.unselectedItems}
                  disableSort={this.props.disableSort}
                  handleSelectAll={this.props.handleSelectAll}
                  toggleSelectOptionDialog={this.props.toggleSelectOptionDialog}
                  togglePromotePlanChangeDialog={this.props.togglePromotePlanChangeDialog}
                />

                <div className={classes.flex}></div>

                <ExportSentExecutiveListButton
                  user={this.props.user}
                  togglePlanDialog={this.props.togglePlanDialog}
                />

                <ListSettingButton
                  user={this.props.user}
                  togglePlanDialog={this.props.togglePlanDialog}
                  toggleListSettingDialog={this.props.toggleListSettingDialog}
                />
              </SearchResultHeaderPanel>

              <SearchResultPanel
                style={{ marginTop: "10px" }}
                user={this.props.user}
                goTo={this.props.goTo}
                items={this.props.filteredItems}
                selectedItems={this.props.selectedItems}
                unselectedItems={this.props.unselectedItems}
                pageInfo={this.props.pageInfo}
                isSelectAll={this.props.isSelectAll}
                selectCount={this.props.selectCount}
                disabled={this.props.disabled}
                handleSelectItem={this.props.handleSelectItem}
                filterIntentKeywords={this.props.filterIntentKeywords}
                enableExecutiveListAdvancedSearch={this.props.enableExecutiveListAdvancedSearch}
                toggleCsvDownloadDialog={this.props.toggleCsvDownloadDialog}
                toggleExecDetailItemDialog={this.props.toggleExecDetailItemDialog}
                togglePlanDialog={this.props.togglePlanDialog}
                togglePromotePlanChangeDialog={this.props.togglePromotePlanChangeDialog}
                selectedAiTagName={this.props.selectedAiTagName}
              />
            </div>
          )
        }
      </div>
    );
  }
}

AddressTable.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  user: PropTypes.object,
  goTo: PropTypes.func.isRequired,
  filteredItems: PropTypes.array,
  selectedItems: PropTypes.object,
  unselectedItems: PropTypes.object,
  pageInfo: PropTypes.object,
  totalCount: PropTypes.number,
  isSelectAll: PropTypes.bool,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleSelectAll: PropTypes.func.isRequired,
  handleSelectItem: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disableSort: PropTypes.bool,
  filterIntentKeywords: PropTypes.array,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  toggleSelectOptionDialog: PropTypes.func.isRequired,
  togglePlanDialog: PropTypes.func.isRequired,
  toggleCsvDownloadDialog: PropTypes.func.isRequired,
  toggleExecDetailItemDialog: PropTypes.func.isRequired,
  toggleListSettingDialog: PropTypes.func.isRequired,
  togglePromotePlanChangeDialog: PropTypes.func.isRequired,
  // AI生成タグ関連
  selectedAiTagName: PropTypes.string,
};

AddressTable.defaultProps = {
  disabled: true,
}

export default withStyles(styles)(AddressTable);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/AddressTable.jsx